import {Avatar} from 'antd'
import {getType} from 'apis/model/base'
import classNames from 'classnames'
import getAvatar from 'helpers/getAvatar'
import getLinkToDetail from 'helpers/getLinkToDetail'
import getTitle from 'helpers/getTitle'
import _ from 'lodash'
import Translate from 'modules/local/Translate'
import React from 'react'
import {IoPerson} from 'react-icons/io5'
import {Link} from 'react-router-dom'
import {BiSolidChurch} from "react-icons/bi";
import dayjs from "dayjs";

export const renderHomeFollower = (container, index) => {
    if (_.isEmpty(container)) {
        return null
    }

    const {owner, creator: item} = container

    const isOrg = getType(_.get(container, 'creator')) === 'organization'

    return (
        <Translate key={index}>
            {(t) => (
                <div className="flex items-center gap-2 md:gap-3">
                    <Avatar
                        src={getAvatar(item)}
                        shape={isOrg ? 'square' : 'circle'}
                        size={40}
                        icon={isOrg ? <BiSolidChurch className="text-color-500"/> :
                            <IoPerson className="text-color-500"/>}
                        className={classNames(
                            'flex flex-center background-200',
                            isOrg ? 'rounded-md' : 'rounded-full'
                        )}
                    />
                    <div className="flex flex-col flex-1 truncate">
                        <div className="flex items-baseline gap-1 italic">
                            <Link
                                to={getLinkToDetail(item)}
                                className="text-xs font-semibold text-color-300 max-lines-1 no-underline">
                                {getTitle(item)}
                            </Link>
                            <span className="flex-1 text-2xs text-color-400 whitespace-no-wrap lowercase">
                                {t('followed')}
                            </span>
                            <span className="text-2xs text-color-500 italic ml-3">
                                {dayjs(_.get(container, 'created')).fromNow()}
                            </span>
                        </div>
                        <Link
                            to={getLinkToDetail(owner)}
                            className="flex-1 font-semibold text-sm text-color-000 no-underline leading-tight truncate">
                            {getTitle(owner)}
                        </Link>
                    </div>
                </div>
            )}
        </Translate>
    )
}
